<div class="field field-text">
  @if (label) {
    <div class="label">{{ label }}</div>
  }
  @if (items?.length) {
    <ul class="app-list app-list--field">
      @for (item of items; track item) {
        <li>
          {{ item.value }}
          <i (click)="onDeleteClicked(item.key)" class="im-icon im-icon-trash im-icon-x delete-icon" [class.disabled]="disabled"></i>
        </li>
      }
    </ul>
  }
  <div class="field field-select field-typeahead position-relative">
    <div class="typeahead-wrap" [class.open]="isOpen">
      <input
        #input
        type="text"
        [class.error-field]="error"
        [disabled]="disabled"
        [inputFormatter]="formatter"
        [ngbTypeahead]="search"
        [resultFormatter]="formatter"
        [resultTemplate]="template"
        (blur)="onBlur(input)"
        (focus)="focus$.next($any($event).target.value)"
        (selectItem)="onSelect($event, input);"
        />
      <div class="fill"></div>
    </div>

    @if (error) {
      <span class="error-field-display">{{error}}</span>
    }

    <ng-template #template let-r="result" let-t="term">
      <div [title]="r?.value">
        <ngb-highlight [result]="r.value" [term]="t"></ngb-highlight>
      </div>
    </ng-template>
  </div>
</div>
